import React from 'react';

import BenchlingProfiler, {logProfilerTimingEvent} from 'performance/BenchlingProfiler';
import {
  TABLE_COLLAPSE_FINISHED_EVENT,
  TABLE_COLLAPSE_STARTED_EVENT,
  TABLE_EXPAND_FINISHED_EVENT,
  TABLE_EXPAND_STARTED_EVENT,
} from 'performance/processNotebookEvents';
import CollapserChevron from 'ui-library/CollapserChevron';
import Tooltip from 'ui-library/floating-ui/Tooltip';

import {TableCollapserContext} from './TableCollapserContext';

export interface TableCollapserChevronProps {
  isTableExpanded: boolean;
  showToolTip?: boolean;
  onToggleCollapsed: () => void;
}
export default class TableCollapserChevron extends React.Component<TableCollapserChevronProps> {
  getTooltipTitle(isTableInitiallyCollapsed: boolean): string | null {
    if (isTableInitiallyCollapsed && !this.props.isTableExpanded && this.props.showToolTip !== false) {
      return 'Table is collapsed by default due to the high number of rows. Click to expand.';
    }
    return null;
  }

  onToggleCollapsed = (): void => {
    logProfilerTimingEvent(
      this.props.isTableExpanded ? TABLE_COLLAPSE_STARTED_EVENT : TABLE_EXPAND_STARTED_EVENT
    );
    this.props.onToggleCollapsed();
  };

  override render(): JSX.Element {
    return (
      <TableCollapserContext.Consumer>
        {({isTableInitiallyCollapsed}) => (
          <Tooltip text={this.getTooltipTitle(isTableInitiallyCollapsed)} disableContentSelection={true}>
            <BenchlingProfiler
              {...(this.props.isTableExpanded ? TABLE_EXPAND_FINISHED_EVENT : TABLE_COLLAPSE_FINISHED_EVENT)}
            >
              <CollapserChevron
                isExpanded={this.props.isTableExpanded}
                name="table"
                onToggleCollapsed={this.onToggleCollapsed}
              />
            </BenchlingProfiler>
          </Tooltip>
        )}
      </TableCollapserContext.Consumer>
    );
  }
}
